import React from 'react'
import { BreadcrumbGroup, Checkbox, Button, Textarea, Form } from 'AWS-UI-Components-React'
import './CreateContractView.css'

export default class CreateContractView extends React.Component {

    render() {
        return (
            <div className="create-contract-page">
                {this.renderBreadcrumb()}
                <div className="create-contract-page-outer-container">
                    <Form 
                        content={
                            <div>
                                <Textarea id="contract-text" className="awsui-util-mb-m" placeholder="Terms &amp; Conditions" rows={20} onChange={this.props.handleContractChange}></Textarea>
                                <Checkbox className="awsui-util-mb-m" label="Set as current" onChange={this.props.handleCurrentCheckboxChange}></Checkbox>
                            </div>}
                        actions={
                            <div>
                                <Button text="Cancel" variant="link" href="/#/contracts"></Button>
                                <Button id="submit-button" text="Submit" variant="primary" onClick={this.props.handleSubmit} disabled={this.props.disableSubmit}></Button>
                            </div>}
                    ></Form>
                </div>
            </div>
        )
    }

    renderBreadcrumb() {
        const items = [
            {
                "text": "Contracts",
                "href": "/#/contracts"
            },
            {
                "text": "Create",
                "href": "/"
            }
        ]
        return <BreadcrumbGroup label="Breadcrumbs" items={items}></BreadcrumbGroup>
    }
}


// WEBPACK FOOTER //
// ./src/components/Contracts/Create/CreateContractView.jsx